export type LastPayout = {
  amount: number;
  createdUnixTimestamp: number;
  currency: string;
};

export type StripePaymentSource = {
  allTimeTotalCents: number;
  currentBalanceCents: number;
  lastPayout: LastPayout | null;
  pendingBalanceCents: number | null;
};

export type SpotifyPaymentSource = {
  allTimeTotalCents: number;
  currentBalanceCents: number;
};

export type FetchCurrentPodcastWalletResponse = {
  hasEverActivatedCampaign: boolean;
  isStripeOnboardingCompleted: boolean;
  currentWalletAmountInCents: number; // deprecated, use sources.total.currentBalanceCents
  pendingWalletAmountInCents: number; // deprecated, user sources.stripe.pendingBalanceCents
  allTimeWalletAmountInCents: number; // this value is the same as allTimeWalletBreakdown.amount
  allTimeWalletBreakdown?: {
    amount: number;
    anchorFee: number;
    net: number; // deprecated, use sources.total.allTimeTotalCents
    paid: number;
    processorFee: number;
    payoutFee: number;
    totalAllTimeEarned: number;
  };
  normalPayoutProcessingFeeInCents: number;
  instantPayoutProcessingFeeInCents: number;
  isPayoutEnabled: boolean;
  isInstantPayoutAvailable: boolean;
  areStripeRequirementsMet: boolean;
  doShowActivateAllButton: boolean;
  lastPayout: LastPayout | null; // deprecated, use sources.stripe.lastPayout
  stripeDashboardURL: string | null;
  w8CollectionRequired: boolean;
  currency: string | null;
  minimumCashoutAmount: number; // In cents
  sources: {
    stripe: StripePaymentSource | null;
    spotifyPayments: SpotifyPaymentSource | null;
    total: { allTimeTotalCents: number; currentBalanceCents: number };
  };
  stripeTransfersEnabled: boolean | null;
};

export async function fetchCurrentPodcastWallet({
  shouldBustCache = false,
} = {}): Promise<FetchCurrentPodcastWalletResponse> {
  const baseUrlPath = '/api/proxy/v3/wallet';
  const urlPath = shouldBustCache
    ? `${baseUrlPath}?useCached=false`
    : baseUrlPath;

  const response = await fetch(urlPath, {
    credentials: 'same-origin',
    method: 'GET',
    cache: shouldBustCache ? 'reload' : 'default',
  });

  if (response.ok) {
    return response.json();
  }
  throw new Error('Unable to fetch current podcast wallet');
}
